import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit, PLATFORM_ID, inject } from '@angular/core';
import { DialogueService } from '../../../../core/services/dialogue.service';

@Component({
  selector: 'app-dialogue-component',
  imports: [CommonModule],
  templateUrl: './dialogue-component.html',
  styleUrls: ['./dialogue-component.scss']
})
export class DialogueComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private rotationIntervalId: number | null = null;

  constructor(private dialogueService: DialogueService) { };

  dialogues: any[] = [];
  currentDialogue: any | null = null;

  ngOnInit(): void {
    if (!this.isBrowser) {
      return;
    }

    this.getDeailogue();
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) {
      return;
    }

    this.rotationIntervalId = window.setInterval(() => {
      this.getRandomDialogue();
    }, 10000);
  }

  ngOnDestroy(): void {
    if (this.rotationIntervalId !== null) {
      window.clearInterval(this.rotationIntervalId);
    }
  }

  getDeailogue() {
    if (!this.isBrowser) {
      return;
    }

    this.dialogueService.getDialogue().subscribe({
      next: (data) => {
        this.dialogues = data || [];
        this.getRandomDialogue();
      },
      error: () => {
        this.dialogues = [];
        this.currentDialogue = null;
      }
    });
  }

  getRandomDialogue(): void {
    if (this.dialogues.length > 0) {
      const randomIndex = Math.floor(Math.random() * this.dialogues.length);
      const randomDialogue = this.dialogues[randomIndex];
      this.currentDialogue = randomDialogue;
    } else {
      this.currentDialogue = null;
    }
  }
}
